import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { DashboardComponent } from '@app/dashboard/dashboard.component';
import { WorkOrderCardComponent } from '@app/dashboard/card/work-order-card.component';
import { OfflineDashboardComponent } from '@app/dashboard/offline/offline-dashboard.component';
import { StorageWarningModule } from '@app/shared/storage-warning/storage-warning.module';
import { MatGridListModule } from '@angular/material/grid-list';
import { ProgressModule } from '@app/shared/progress/progress.module';
import { MatCardModule } from '@angular/material/card';
import { RouterModule } from '@angular/router';
import { PipesModule } from '@app/shared/pipes/pipes.module';
import { TranslateModule } from '@ngx-translate/core';
import { MatIconModule } from '@angular/material/icon';
import { PutOnHoldInfoDialogModule } from '@app/shared/put-on-hold-info-dialog/put-on-hold-info-dialog.module';
import { DropdownDialogModule } from '@app/shared/dropdown-dialog/dropdown-dialog.module';
import { MatButtonModule } from '@angular/material/button';
import { MatTabsModule } from '@angular/material/tabs';
import { FormsModule } from '@angular/forms';
import { EmptyListModule } from '@app/shared/empty-list/empty-list.module';
import { AutoFocusDirective } from '@app/shared/directives/auto-focus.directive';
import { MatSelectModule } from '@angular/material/select';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { CardModule } from '@app/shared/card/card.module';
import { OfflineDownloadDialogModule } from '@app/shared/offline-download-dialog/offline-download-dialog.module';

@NgModule({
  declarations: [DashboardComponent, WorkOrderCardComponent, OfflineDashboardComponent, AutoFocusDirective],
  imports: [
    CommonModule,
    RouterModule,
    TranslateModule,
    FormsModule,
    // material modules
    MatGridListModule,
    MatCardModule,
    MatIconModule,
    MatButtonModule,
    MatTabsModule,
    // dwo modules
    ProgressModule,
    PipesModule,
    PutOnHoldInfoDialogModule,
    StorageWarningModule,
    DropdownDialogModule,
    EmptyListModule,
    MatSelectModule,
    MatProgressSpinnerModule,
    CardModule,
    OfflineDownloadDialogModule,
  ],
  exports: [DashboardComponent, WorkOrderCardComponent, OfflineDashboardComponent],
})
export class DashboardModule {}
